var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-radio",on:{"click":function($event){return _vm.$emit('change')}}},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"radio",class:{ checked: _vm.checked }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }